import { Component, OnInit } from '@angular/core';
import { CertificateListService, NotificationService, DateFormatService, WalletService, ProfileService, countries } from '@core';
import { TranslateService } from '@ngx-translate/core';
import endOfMonth from 'date-fns/endOfMonth';
import { saveAs } from 'file-saver';
import { NotificationKeys, paymentProcessorValues, ResponseStatus, Services, UserTypes } from 'src/app/core/enums/keys.enum';

@Component({
    selector: 'app-transaction-history',
    templateUrl: './transaction-history.component.html',
    styleUrls: ['./transaction-history.component.less'],
    standalone: false
})
export class TransactionHistoryComponent implements OnInit {
	transactionDetails: any[] = [];
	loading: boolean = false;
	exporttransactionHistory: string = '';
	isExporting: boolean = false;
	viewServiceChargeModal: boolean = false;
	isGenerating: boolean = false;
	dropdownToggle: boolean = true;
	error = "";
	accessCost?: number;// provisionCost?: number;
	verificationCost?: number;
	sharingCost?: number;
	retrievalCost?: number;
	requestConfirmationCost?: number;
	userTypes = UserTypes;
	countries = countries;
	wallet: any;
	unitBalance: number = 0;
	unitRate: any;
	currency: any;
	userCountry: any;
	serviceChargeModalText: string = "BILLING.SERVICE_CHARGE_MODAL_TEXT"
	user: any;

	accessLocalCost: number = 0;
	sharingLocalCost: number = 0;
	requestConfirmationLocalCost: number = 0;
	retrievalLocalCost: number = 0;
	verificationLocalCost: number = 0;

	ranges = {
		Today: [new Date(), new Date()],
		'This Month': [new Date(), endOfMonth(new Date())],
	};
	searchParams: {
		date_from: string;
		date_to: string;
		range: any;
	};
	q: {
		date_from: string;
		date_to: string;
		range: any;
	}

	constructor(
		private certificateService: CertificateListService,
		private dateConfig: DateFormatService,
		private notify: NotificationService,
		private paymentService: CertificateListService,
		private walletService: WalletService,
		private profileService: ProfileService,
		private translate: TranslateService
	) {
		this.user = this.profileService.getLocalStorageUser();
		this.searchParams = {
			range: [new Date(), new Date()],
			date_from: this.dateConfig.formatDate(String(new Date())),
			date_to: this.dateConfig.formatDate(String(new Date())),
		};
		this.userCountry = this.countries.find((val: any) => val?.code === this.user?.exam_country_profile_code);
		this.onDateChange(this.searchParams.range);
		this.q = {
			range: [new Date(), new Date()],
			date_from: this.dateConfig.formatDate(String(new Date())),
			date_to: this.dateConfig.formatDate(String(new Date())),
		};
	}

	// Search Query



	qt: {
		amount: number;
		units: number;
		unitRate: number;
		processor: string;
		selectedAmount: number;
	} = {
			amount: 0,
			units: 0,
			unitRate: 1,
			processor: "",
			selectedAmount: 0,
		};

	//PAGINATION
	current_page: number = 0;
	total: number = 0;
	from: number = 0;
	to: number = 0;
	lastpage: number = 0;
	page: any[] = [];
	meta: any;
	nextPage: string = '';
	paginator = 0;
	tempName = null;

	ngOnInit(): void {
		this.loadTransactions();
		this.getWallet();
		this.getServiceCost();

	}

	showTotal() {
		return `<div>
					<button>Export</button>
				</div>`
	}

	next(id: number): void {
		this.loading = true;
		let url = `?start_date=${this.searchParams.date_from}&end_date=${this.searchParams.date_to}` + '&page_size=10&page=' + id;
		this.certificateService
			.nextBillingWallet(url)
			.then(res => {
				if (res.error) {
					this.notify.error('', res.error, NotificationKeys.HISTORY);
					this.loading = false;
					return;
				}
				this.transactionDetails = res?.data.data.sort(
					(a: any, b: any) => b.created_date - a.created_date,
				);
				this.meta = res?.data.path;
				this.current_page = res?.data.current_page;
				this.lastpage = res?.data.last_page;
				this.from = res?.data.from;
				this.to = res?.data.to;
				this.total = res?.data.total;
				this.nextPage = res?.data.next;
				this.loading = false;
			})
			.catch(() => {
				this.loading = false;
			});
	}

	loadTransactions(): void {
		this.loading = true;
		this.certificateService
			.tansactionHistory()
			.then(res => {
				this.transactionDetails = res?.data?.data.sort(
					(a: any, b: any) => b.created_date - a.created_date,
				);
				this.meta = res?.data.path;
				this.current_page = res.data.current_page;
				this.lastpage = res?.data.last_page;
				this.from = res?.data.from;
				this.to = res?.data.to;
				this.total = res?.data.total;
				this.nextPage = res?.data.next;
				this.loading = false;
			})
			.catch(() => {
				this.loading = false;
			});
	}

	// Filter Actions
	onDateChange(result: any): void {
		this.searchParams.date_from = this.dateConfig.formatDate(result[0]);
		this.searchParams.date_to = this.dateConfig.formatDate(result[1]);
	}
	filterOnChange(): void {
		this.q.date_from = this.searchParams.date_from;
		this.q.date_to = this.searchParams.date_to;
		this.q.range = this.searchParams.range;
	}

	generateTrasactionHistory() {
		this.isGenerating = true;
		let url = `?start_date=${this.searchParams.date_from}&end_date=${this.searchParams.date_to}&page_size=10`;
		this.certificateService
			.generatetransactionHistory(url)
			.then(res => {
				this.transactionDetails = res?.data?.data?.sort(
					(a: any, b: any) => b.created_date - a.created_date,
				);
				this.meta = res?.data.path;
				this.current_page = res.data.current_page;
				this.lastpage = res?.data.last_page;
				this.from = res?.data.from;
				this.to = res?.data.to;
				this.total = res?.data.total;
				this.nextPage = res?.data.next;
				this.isGenerating = false;
			})
			.catch(err => {
				this.isGenerating = false;
				console.warn(err);
			});
	}

	exportTrasactionHistory() {
		this.isExporting = true;
		let url = `?start_date=${this.searchParams.date_from}&end_date=${this.searchParams.date_to}`;
		this.certificateService.exporttransactionHistory(url).subscribe(
			res => {
				saveAs(res, `${this.translate.instant('BILLING.TRANSACTION-HISTORY.TRANSACTION_HISTORY')}.csv`);
				this.isExporting = false;
			},
			error => {
				this.isExporting = false;
				this.notify.error('', error);
			},
		);
	}

	toggleDropdown() {
		this.dropdownToggle = !this.dropdownToggle;
	}

	displayServiceCharge() {
		this.viewServiceChargeModal = true;
	}

	dismissServiceChargeModal() {
		this.viewServiceChargeModal = false;
	}

	loadUnit(): void {
		this.paymentService
			.getUnit()
			.then(res => {
				if (res.status === ResponseStatus.FAILED) {
					this.error = res.message;
					return;
				}
				this.loading = false;
				this.qt.unitRate = res.data;
			})
			.catch(err => {
				this.error = err;
				this.loading = false;
			});
	}


	getServiceCost() {
		this.walletService
			.walletServices()
			.then(res => {

				const data = res?.data?.data;

				this.accessCost = this.getCost(data, Services.ACCESSING);
				this.verificationCost = this.getCost(data, Services.CONFIRMATION);
				this.sharingCost = this.getCost(data, Services.SHARING);
				this.requestConfirmationCost = this.getCost(data, Services.REQUEST_CONFIRMATION);
				this.retrievalCost = this.getCost(data, Services.EXAM_NUMBER_RETRIEVAL);

				this.calculateLocalValue();

			})
			.catch(err => {
				console.warn(err);
			});
	}

	getCost(data: any[], serviceName: string): number {
		const service = data?.find((i: any) => i.item?.toLowerCase() === serviceName);
		const unitValue = service?.service_values?.find(
			(v: any) => v.value_text?.toLowerCase() === paymentProcessorValues.UNIT,
		);
		return unitValue?.value || 0;
	}

	calculateLocalValue() {

		const rate = this.unitRate || 0; 

		this.accessLocalCost = (this.accessCost || 0) * rate;
		this.sharingLocalCost = (this.sharingCost || 0) * rate;
		this.requestConfirmationLocalCost = (this.requestConfirmationCost || 0) * rate;
		this.retrievalLocalCost = (this.retrievalCost || 0) * rate;
		this.verificationLocalCost = (this.verificationCost || 0) * rate;

	}

	getWallet = () => {
		// this.loading_wallet = true;
		this.walletService.getwalletBalance().then((res: any) => {
			if (res?.error) {
				return;
			}
			this.unitBalance = res?.data?.unit_balance;
			this.wallet = res?.data;
			// this.loading_wallet = false;
			this.unitRate = res?.data?.currency_unit_rate;
			this.currency = res?.data?.payment_currency;

			this.calculateLocalValue();

		});
	};


	isLocalTransaction() {
		return this.currency === (this.countries.find((val: any) => val?.code === this.user?.exam_country_profile_code))?.currency;
	}

	translateAction(action: string) {
		return this.translate.instant(`WALLET_ACTIONS.${action.toUpperCase()}`);
	}

}
